/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// custom-faq.liquid toggle aria-expanded
$('.cfaq-i_head').click(function(){
  $(this).attr('aria-expanded', function (i, attr) {
    return attr == 'true' ? 'false' : 'true'
});
});

// show hide size chart
$('#sizechartclose').click(function(){
  $('#sizechartcont').hide()
  $('html').css('overflow', 'scroll')
})
$('.csizechart').click(function(){
  $('#sizechartcont').show()
  $('html').css('overflow', 'hidden')
})

// code for the view more feature collection start
// ajax add to cart
function ajaxadd(){
    // Accessing the element that triggered the event
    var element = event.target || event.srcElement;

    // Getting the value of the data-id attribute
    var varid = element.getAttribute('data-id');
  data = {
      "id": varid,
      "quantity": 1,

    }
jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        console.log("product added to cart")
        window.location.href = "/cart";
      }
    });
}
// view cart
function quashow(event,prodid){
  event.preventDefault();
  $(`.quac${prodid}`).css('display','flex');
}

let quaclose = function(){
  $('.quickAdd-modal-cont').hide();
}

// $('.qam-remove').click(function(){
//   $('.quickAdd-modal-cont').hide();
// })

//variant change
function varch(prodid,event){
    console.log(`.quac${prodid} .qam-atc`)
  $(`.quac${prodid} .qam-size_child`).removeClass('qam-size_active')
  $(event.target).addClass('qam-size_active');
  let newvarid = $(event.target).data('id');
  $(`.quac${prodid} .qam-atc`).attr('data-id',parseInt(newvarid));
}

//image change 
function changeimage(event,sectionid,productid,  img1, img2){
  sectionid = '#shopify-section-' + sectionid;
  console.log(event)
  console.log(`${sectionid} .js-product-${productid} .product-card__img`)
  $(`${sectionid} .js-product-${productid} .product-card__img`).attr("srcset",img1);  
  $(`${sectionid} .js-product-${productid} .product-card__img-hover`).attr("srcset",img2);  
  $(`${sectionid} .js-product-${productid} .qam-img`).attr("srcset",img1);  
  $(`${sectionid} .js-product-${productid} .cvs-child`).removeClass("cvs-active");  
  $(event.currentTarget).addClass("cvs-active");  
}